export default __webpack_public_path__ + "static/media/kostyambl-ph-colored.f21e12b1.webp";